import { Injectable } from "@angular/core";
import { DeliveryMode } from "@spartacus/cart/base/root";
import { DELIVERY_MODE_NORMALIZER } from "@spartacus/checkout/base/core";
import { OccCheckoutDeliveryModesAdapter } from "@spartacus/checkout/base/occ";
import { Occ, tryNormalizeHttpError, backOff, isJaloError } from "@spartacus/core";
import { Observable, catchError, map } from "rxjs";

@Injectable()
export class CustomOccCheckoutDeliveryModesAdapter extends OccCheckoutDeliveryModesAdapter {
    /**
     * Below method has no modification compared to OOTB.
     * However, we need to override it to ensure that our custom OccConfig (i.e.customDefaultOccCheckoutConfig) is used
     */
    public override getSupportedModes(
        userId: string,
        cartId: string
    ): Observable<DeliveryMode[]> {
        return this.http
            .get<Occ.DeliveryModeList>(this.getDeliveryModesEndpoint(userId, cartId))
            .pipe(
                catchError((error) => {
                    throw tryNormalizeHttpError(error, this.logger);
                }),
                backOff({
                    shouldRetry: isJaloError,
                }),
                map((listResponse) => listResponse.deliveryModes ?? []),
                this.converter.pipeableMany(DELIVERY_MODE_NORMALIZER)
            );
    }
}